module.exports = __webpack_public_path__ + "static/team-2-3-2126e7bc9c8e58998de5db31b7f0c2b8.jpg";